<template>
    <div>
        <v-row class="pa-10">
            <v-text-field v-model="search" outlined dense label="Search"></v-text-field>
        </v-row>
        <v-data-table :items="reports" :headers="headers" :loading="loading" :search="search">
            <template v-slot:item.uploadDate="{ item }">{{
                item.uploadDate ? new Date(item.uploadDate).toDateString() : ''
            }}</template>
            <template v-slot:item.download="{ item }"
                ><v-icon color="#db5120" style="cursor: pointer" @click="downloadFile(item._id)">{{
                    mdiDownload
                }}</v-icon></template
            >
        </v-data-table>
        <v-snackbar v-model="snackbar">
            {{ snackbarMessage }}

            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" color="white" @click="snackbar = false"> Close </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { fetchPrtgReport, downloadReport } from '@/api'
import { mdiDownload } from '@mdi/js'

export default {
    metaInfo: { title: `Your Account`, subTitle: `Dashboard` },
    name: `CdfwPrtg`,
    data() {
        return {
            search: ``,
            snackbar: false,
            snackbarMessage: ``,
            mdiDownload,
            loading: false,
            reports: [],
            headers: [
                {
                    text: 'Report',
                    align: 'start',
                    sortable: true,
                    value: 'filename'
                },
                {
                    text: 'Upload Date',
                    align: 'start',
                    sortable: true,
                    value: 'uploadDate'
                },
                {
                    text: 'Download',
                    align: 'center',
                    sortable: true,
                    value: 'download'
                }
            ]
        }
    },
    computed: {},
    created() {
        this.fetchData()
    },
    methods: {
        async fetchData() {
            this.loading = true
            const results = (await fetchPrtgReport({})).data
            this.reports = results.map((item) => ({
                ...item,
                uploadDate: item.uploadDate ? new Date(item.uploadDate).toDateString() : ''
            }))
            this.loading = false
        },
        async downloadFile(id) {
            try {
                const result = await downloadReport({
                    trackId: id
                })
                const fileUrl = URL.createObjectURL(result.data)
                const newFile = document.createElement('a')
                newFile.href = fileUrl
                newFile.download = id
                newFile.click()
            } catch (e) {
                this.snackbar = true
                this.snackbarMessage = `Error downloading file`
                console.error(e)
            }
        }
    }
}
</script>
